import React from "react";
import SelectorComponent from "components/SelectorComponents"
import { withStyles } from '@material-ui/core';
import DateRangePicker from "components/DateRangePicker"
import Tooltip from "storybookComponents/tooltip_new"

const styles = () => ({
  topBar: {
    background: "white",
    border: "1px solid #dadada",
    height: 52,
    marginBottom: 12,
    display: "flex",
    alignItems: "center",
    padding: 16,
  },
  divider: {
    width: 1,
    height: 24,
    margin: "0px 20px",
    background: "#dadada"
  },
  disable: {
    pointerEvents: "none",
    opacity: 0.5
  }
})



const CampaignWrapper = ({ children, classes, firstFilterData }) => {
  if (firstFilterData.value.length < 1) {
    return <Tooltip text="Select Property(s) first">
      <div>
        <div className={classes.disable}>
          {children}
        </div>
      </div>
    </Tooltip>
  }

  return (
    <div>{children}</div>
  )
}


const FilterBar = ({ classes, firstFilterData, secondFilterData, thirdFilterData, fourthFilterData, children }) => {
  return (
    <div className={classes.topBar}>
      {
        (firstFilterData) &&
        <SelectorComponent
          optionValue={firstFilterData.optionValue}
          placeholder={firstFilterData.placeholder}
          searchPlaceHolder={firstFilterData.searchPlaceHolder}
          onChange={firstFilterData.onChange}
          multiple={firstFilterData.multiple}
          singleSelect={firstFilterData.singleSelect}
          value={firstFilterData.value}
          selectAllText={firstFilterData.selectAllText}
          getCustomLabel={firstFilterData.getCustomLabel}
        />

      }
      {
        thirdFilterData &&
        <>
          <div className={classes.divider}></div>
          <CampaignWrapper firstFilterData={firstFilterData} classes={classes}>
            <SelectorComponent
              optionValue={thirdFilterData.optionValue}
              placeholder={thirdFilterData.placeholder}
              searchPlaceHolder={thirdFilterData.searchPlaceHolder}
              onChange={thirdFilterData.onChange}
              multiple={thirdFilterData.multiple}
              singleSelect={thirdFilterData.singleSelect}
              groupBy={thirdFilterData.groupBy}
              value={thirdFilterData.value}
              selectAllText={thirdFilterData.selectAllText}
              getCustomLabel={thirdFilterData.getCustomLabel}
            />
          </CampaignWrapper>

        </>
      }
      {
        (fourthFilterData && fourthFilterData.optionValue) &&
        <>
          <div className={classes.divider}></div>
          <SelectorComponent
            optionValue={fourthFilterData.optionValue}
            onChange={fourthFilterData.onChange}
            singleSelect={fourthFilterData.singleSelect}
            value={fourthFilterData.value}
            getCustomLabel={fourthFilterData.getCustomLabel}
            disableSearch={fourthFilterData.disableSearch}
            disableAllSelect={fourthFilterData.disableAllSelect}
            height={fourthFilterData.height}
            width={fourthFilterData.width}
          />

        </>
      }
      {
        secondFilterData && secondFilterData.value &&
        <>
          <div className={classes.divider}></div>
          <DateRangePicker
            timezoneOffset={secondFilterData.timezoneOffset}
            value={secondFilterData.value}
            position={secondFilterData.position}
            handleApply={secondFilterData.handleApply}
          />
        </>
      }
      {
        children &&
        <>
          <div className={classes.divider}></div>
          {children}
        </>
      }

    </div>
  )
}

export default withStyles(styles)(FilterBar)